module.exports = __webpack_public_path__ + "5fb4d206827e757c3d92457077a76c4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/galeriaFotos/resplendor2.jpg
// module id = 70
// module chunks = 0